module.exports = __webpack_public_path__ + "static/media/combination.516c57d2.png";